const APOSTRA_ADMIN_HOSTNAMES = new Set([
  'admin.apostra.com',
  'admin.staging.apostra.com',
  'localhost',
  '127.0.0.1',
])

/**
 * The public admin hosts keep separate signed-out identities during the
 * product-brand cutover. Apostra and local development use the Apostra auth
 * shell; the explicit Interchange and preview hosts retain the legacy shell.
 */
export function isApostraAdminHost(
  hostname = globalThis.location?.hostname ?? '',
): boolean {
  return APOSTRA_ADMIN_HOSTNAMES.has(hostname)
}
